import { SweetAlertService } from "@/CommonVueCore/src/services/sweetAlert2Service/sweetAlert2Service";
import { useAuthAppStore } from "@/store/stores/authStore";
import { ErrorMessageService } from "@/services/errorMessageService/errorMessageService";

export class SupplierService {
  async getAllEntities({ supplierServiceClient }) {
    var response = await supplierServiceClient.get({
      route: "/supplier/get-all-entities-paged",
      // params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async setImport(
    file,
    deleteNotInFile,
    cproxServiceClient,
    fileManagerService
  ) {
    try {
      const convertedFile = await fileManagerService.convertToByteArray(file);

      const response = await cproxServiceClient.supplier.post({
        data: {
          File: JSON.stringify(Array.from(convertedFile)),
          DeleteNotInFile: deleteNotInFile,
        },
        route: "/supplier/import-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
        errorCallback: () => {
          
        }
      });

      console.log("response setImport ", response);

      if (response && response.status) {
        return response;
      } else {
        throw new Error(window.$t("Invalid_Response_From_ContainerService"));
      }
    } catch (error) {
      console.log("error ldsfkdsşlkfşslkfdlş", error);

      if (error)
        new SweetAlertService().error(
          "Error",
          error.response?.data?.ResponseStatus?.Errors?.length
            ? error.response.data.ResponseStatus.Errors.map(
                (e) => e.Message
              ).join("\n")
            : (
              (new ErrorMessageService()).getUserMessage({ errorCode: error.response?.data?.ResponseStatus?.errorCode, message: error.response?.data?.ResponseStatus?.Message })
            )
        );
      else {
        throw error;
      }
    }
  }

  async setExport(filters, cproxServiceClient) {
    try {
      const response = await cproxServiceClient.supplier.post({
        data: {
          Filters: filters,
        },
        route: "/supplier/download-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });

      if (response && response.status) {
        return response;
      } else {
        throw new Error(window.$t("Invalid_Response_From_ContainerService"));
      }
    } catch (error) {
      if (error.isAxiosError) {
        this._sweetAlertService.showAlert(
          "Error",
          error.response?.data?.ResponseStatus?.Errors?.length
            ? error.response.data.ResponseStatus.Errors.map(
                (e) => e.Message
              ).join("\n")
            : (
              (new ErrorMessageService()).getUserMessage({ errorCode: error.response?.data?.ResponseStatus?.errorCode, message: error.response?.data?.ResponseStatus?.Message })
            ),
          "error"
        );
      } else {
        console.error("Unexpected error from import-entities-with-file", error);
        throw error;
      }
    }
  }
}
